export const defaultMessage: string = "No records in our system.";
